<template>
	<div class="partnerdashboard">
		<header>
			<h2>Moje konfiguracje</h2>
		</header>

		<div class="partnerdashboard__list-container">
			<ul class="partnerdashboard__list">
				<li class="partnerdashboard__list--header">
					<span
						v-for="header_item in header"
						:key="header_item.field"
						:class="'partnerdashboard__' + header_item.field"
						>{{ header_item.title }}</span
					>
				</li>
				<div v-if="unitConfigurations.length === 0">Brak konfiguracji.</div>
				<li
					class="partnerdashboard__list--item"
					v-for="config in unitConfigurations"
					:key="config.id"
				>
					<span class="partnerdashboard__timestamp">{{ config.created_at }}</span>
					<span class="partnerdashboard__unit">
						{{ config.unit_name }}
						<img :src="require(`@/assets/pictures/${config.image}`)" />
					</span>
					<span class="partnerdashboard__price">{{ formatPrice(config.price) }}</span>
					<span class="partnerdashboard__edit uppercased-text">
						<router-link
							:to="{name: 'load-configuration', params: {unitConfigurationId: config.id}}"
							>Wróć do edycji</router-link
						>
					</span>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import * as R from 'ramda';
import dayjs from 'dayjs';
import AppDataMixin from '@/mixins/app-data';
import {api} from '@/core/services/api';
import {formatPrice} from '../../../common/helpers/format-price';

const formatDate = R.pipe(dayjs, dayjsDate => dayjsDate.format('YYYY-MM-DD HH:mm'));

const header = [
	{
		field: 'timestamp',
		title: 'Data',
	},
	{
		field: 'unit',
		title: 'Unit stomatologiczny',
	},
	{
		field: 'price',
		title: 'Cena',
	},
	{
		field: 'edit',
		title: 'Edycja',
	},
];

export default {
	name: 'PartnerDashboard',
	mixins: [AppDataMixin],
	data() {
		return {
			formatPrice,
			header,
			unitConfigurations: [],
		};
	},
	mounted() {
		this.fetchUnitConfigurations();
	},
	methods: {
		async fetchUnitConfigurations() {
			const {result} = (await api.get('/getPartnerConfigurations')).data;
			this.unitConfigurations = R.map(item =>
				R.pipe(
					R.over(R.lensProp('created_at'), formatDate),
					R.assoc(
						'unit_name',
						R.path(['units', item.configuration_data.unit, 'fullName'], this.appData)
					),
					R.assoc('image', R.path(['units', item.configuration_data.unit, 'image'], this.appData))
				)(item)
			)(result);
		},
	},
};
</script>
